<div class="flex rounded-b-sm border-t-4 p-4" [attr.type]="type()">
	<mat-icon class="w-12 grow-0">info_outline</mat-icon>
	<div class="grow">
		<ng-content></ng-content>
	</div>
	@if (dismissable) {
		<mat-icon class="grow-0 cursor-pointer" (click)="dismiss.emit()">close</mat-icon>
	}
</div>
